import { render, staticRenderFns } from "./ToastNotifications.vue?vue&type=template&id=5bcd271b&scoped=true"
import script from "./ToastNotifications.vue?vue&type=script&lang=js"
export * from "./ToastNotifications.vue?vue&type=script&lang=js"
import style0 from "./ToastNotifications.vue?vue&type=style&index=0&id=5bcd271b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd271b",
  null
  
)

export default component.exports